import { fetchActiveInvestigatorsForReport } from "../../../apis/dashboard";

export const FETCH_INVESTIGATORS_FOR_INVESTIGATOR_REPORT_REQUESTED =
  "FETCH_INVESTIGATORS_FOR_INVESTIGATOR_REPORT_REQUESTED";
export const FETCH_INVESTIGATORS_FOR_INVESTIGATOR_REPORT_SUCCESS =
  "FETCH_INVESTIGATORS_FOR_INVESTIGATOR_REPORT_SUCCESS";
export const FETCH_INVESTIGATORS_FOR_INVESTIGATOR_REPORT_FAILED =
  "FETCH_INVESTIGATORS_FOR_INVESTIGATOR_REPORT_FAILED";

export const SET_INVESTIGATOR_EXPORT_FILTERS =
  "SET_INVESTIGATOR_EXPORT_FILTERS";
export const SET_INVESTIGATOR_PERIOD_FROM_FILTER =
  "SET_INVESTIGATOR_PERIOD_FROM_FILTER";
export const SET_INVESTIGATOR_PERIOD_TO_FILTER =
  "SET_INVESTIGATOR_PERIOD_TO_FILTER";

export const SET_INVESTIGATOR_ACCOUNT_EXECUTIVE =
  "SET_INVESTIGATOR_ACCOUNT_EXECUTIVE";
export const SET_INVESTIGATOR_ACCOUNT_MANAGER =
  "SET_INVESTIGATOR_ACCOUNT_MANAGER";

export const EXPORT_INVESTIGATOR_REPORT_REQUESTED =
  "EXPORT_INVESTIGATOR_REPORT_REQUESTED";
export const EXPORT_INVESTIGATOR_REPORT_SUCCESS =
  "EXPORT_INVESTIGATOR_REPORT_SUCCESS";
export const EXPORT_INVESTIGATOR_REPORT_FAILED =
  "EXPORT_INVESTIGATOR_REPORT_FAILED";

import * as api from "../../../apis/dashboard";
import { setNewReportInitiated } from "../reports";
export const fetchInvestigatorsForInvestigatorReport =
  () => (dispatch, getState) => {
    dispatch({ type: FETCH_INVESTIGATORS_FOR_INVESTIGATOR_REPORT_REQUESTED });

    // fetch all investigators without funder and circle filters, filters out inactive and demo subscribers
    return api
      .fetchActiveInvestigatorsForReport()
      .then((result) => {
        if (result) {
          return dispatch({
            type: FETCH_INVESTIGATORS_FOR_INVESTIGATOR_REPORT_SUCCESS,
            data: result || [],
          });
        } else {
          return dispatch({
            type: FETCH_INVESTIGATORS_FOR_INVESTIGATOR_REPORT_FAILED,
            data: {},
          });
        }
      })
      .catch((error) => {
        return dispatch({
          type: FETCH_INVESTIGATORS_FOR_INVESTIGATOR_REPORT_FAILED,
          data: {},
        });
      });
  };

export const setInvestigatorExportFilters = (value) => ({
  type: SET_INVESTIGATOR_EXPORT_FILTERS,
  data: value,
});
export const setInvestigatorPeriodFromFilter = (value) => ({
  type: SET_INVESTIGATOR_PERIOD_FROM_FILTER,
  data: value,
});
export const setInvestigatorPeriodToFilter = (value) => ({
  type: SET_INVESTIGATOR_PERIOD_TO_FILTER,
  data: value,
});

export const setInvestigatorAccountExecutive = (value) => ({
  type: SET_INVESTIGATOR_ACCOUNT_EXECUTIVE,
  data: value,
});
export const setInvestigatorAccountManager = (value) => ({
  type: SET_INVESTIGATOR_ACCOUNT_MANAGER,
  data: value,
});

export const exportInvestigatorReport = () => (dispatch, getState) => {
  dispatch({ type: EXPORT_INVESTIGATOR_REPORT_REQUESTED });

  const state = getState().investigatorReport;
  const investigatorIds = state.investigators.map((i) => i.id);
  const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
  console.log(timeZone);

  const values = {
    investigators: investigatorIds,
    periodFrom: state.periodFrom,
    periodTo: state.periodTo,
    timeZone,
    // accountExecutive: state.accountExecutive,
    // accountManager: state.accountManager,
  };

  return api.exportInvestigatorReport(values).then((result) => {
    if (result) {
      dispatch({ type: EXPORT_INVESTIGATOR_REPORT_SUCCESS, data: {} });
      return dispatch(setNewReportInitiated());
    } else {
      dispatch({ type: EXPORT_INVESTIGATOR_REPORT_FAILED, data: {} });
      return dispatch({
        type: "SET_SNACKBAR_MESSAGE",
        data: { message: "app.general.exportFailed", isSuccess: false },
      });
    }
  });
};

const initial = {
  includedInvestigators: [],
  investigators: [],
  periodFrom: null,
  periodTo: null,
  accountExecutive: null,
  accountManager: null,
  isLoading: false,
  error: null,
};

export const reducer = (state = initial, action) => {
  switch (action.type) {
    case FETCH_INVESTIGATORS_FOR_INVESTIGATOR_REPORT_REQUESTED:
      return { ...state, isLoading: true };
    case FETCH_INVESTIGATORS_FOR_INVESTIGATOR_REPORT_SUCCESS:
      return { ...state, isLoading: false, investigators: action.data };
    case FETCH_INVESTIGATORS_FOR_INVESTIGATOR_REPORT_FAILED:
      return { ...state, isLoading: false, error: true };

    case SET_INVESTIGATOR_EXPORT_FILTERS:
      return { ...state, includedInvestigators: action.data };
    case SET_INVESTIGATOR_PERIOD_FROM_FILTER:
      return { ...state, periodFrom: action.data };
    case SET_INVESTIGATOR_PERIOD_TO_FILTER:
      return { ...state, periodTo: action.data };
    case SET_INVESTIGATOR_ACCOUNT_EXECUTIVE:
      return { ...state, accountExecutive: action.data };
    case SET_INVESTIGATOR_ACCOUNT_MANAGER:
      return { ...state, accountManager: action.data };

    case EXPORT_INVESTIGATOR_REPORT_REQUESTED:
      return { ...state, isLoading: true };
    case EXPORT_INVESTIGATOR_REPORT_SUCCESS:
      return { ...state, isLoading: false };
    case EXPORT_INVESTIGATOR_REPORT_FAILED:
      return { ...state, isLoading: false, error: true };

    default:
      return state;
  }
};

import { createSelector } from "reselect";
const mainSelector = (state) => state.investigatorReport;

export const investigatorExportFiltersSelector = createSelector(
  mainSelector,
  (s) => (s && s.includedInvestigators) || [],
);
export const investigatorPeriodFromSelector = createSelector(
  mainSelector,
  (s) => s && s.periodFrom,
);
export const investigatorPeriodToSelector = createSelector(
  mainSelector,
  (s) => s && s.periodTo,
);
export const investigatorAccountExecutiveSelector = createSelector(
  mainSelector,
  (s) => s && s.accountExecutive,
);
export const investigatorAccountManagerSelector = createSelector(
  mainSelector,
  (s) => s && s.accountManager,
);
export const investigatorsListSelector = createSelector(
  mainSelector,
  (s) => (s && s.investigators) || [],
);
